import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import type { SiestaSkill } from '../types';
import { invalidateCompanySkillQueries } from './invalidateCompanySkillQueries';

type SaveSkillParams = {
  id?: string;
  name: string;
  description: string;
  markdown: string;
  companyFilesVisible: boolean;
  canGenerateSuitabilityReports: boolean;
  isEnabled: boolean;
};

export default function useSaveTenantSkill() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: SaveSkillParams) => {
      const body = {
        name: params.name,
        description: params.description,
        markdown: params.markdown,
        companyFilesVisible: params.companyFilesVisible,
        canGenerateSuitabilityReports: params.canGenerateSuitabilityReports,
        isEnabled: params.isEnabled,
      };
      if (params.id) {
        return api.put<SiestaSkill>(`/tenant/custom-skills/${params.id}`, body);
      }
      // Skills built from this screen always run in the sandbox: that's the technical detail an
      // admin shouldn't have to reason about. An edit leaves the setting out, so the server keeps
      // whatever staff last chose in the secret menu.
      return api.post<SiestaSkill>('/tenant/custom-skills', { ...body, requiresSandbox: true });
    },
    onSuccess: () => {
      void invalidateCompanySkillQueries(queryClient);
    },
  });
}
